define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/action/Controller"
], function(declare,lang,_,Controller) {

	var	_testValue = function(/*String*/text, /*String*/v) {
		return v && v.toLowerCase && (v.toLowerCase().indexOf(text) >= 0);
	},
	
	_testAttribute = function(/*String[]*/ids, /*String*/text, /*Unused*/x, /*Node*/node) {
		return _.some(ids, function(id) {
			var v = node[id];
			if (v) {
				if (_.isArray(v)) {
					return _.some(v, lang.partial(_testValue, text));
				}
				
				if (_.isObject(v)) {
					return _.some(v, function(value, key) {
						return _testValue(text, value);
					});
				}
				
				return _testValue(text, v);
			}
			
			return null;
		});
	};
		
	return declare(Controller, {
		_onAction: function() {
			// summary: set view query to test for given text
			var	text = this.actionValue.toLowerCase();
			var	test = text ? {test: lang.partial(_testAttribute, this.widget.findAttributes, text)} : null;
			this.widget.set("query", test ? {"__Find__": test} : null);
		},
		
		postProcessSuccess: function() {
			// summary: redraw view
			return this.widget.redrawData();
		}
	});
});